import React, { Component } from 'react';
import { db } from '../../firebase';
import withAuthorization from '../Session/withAuthorization';
import {Input,Form, Label, FormGroup, Button } from 'reactstrap';
import {toast} from 'react-toastify';
import * as companies from "../../constants/companies";
import { functions } from '../../firebase/firebase';
import { compose } from 'recompose';
import "./index.css";
import Spinner from '../Spinner';
import { EMAIL_PREFIX } from '../../constants/common';

const SignUpPage = () =>
  <div>
    <SignUpForm />
  </div>

const updateByPropertyName = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  username: '',
  alias: '',
  passwordOne: '',
  passwordTwo: '',
  company: companies.UTENOS_PREKYBA,
  telephone: '',
  isModerator:false,
  error: null,
  isLoading:false,
};

class SignUpForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const {
      username,
      alias,
      passwordOne,
      company,
      isModerator,
      telephone
    } = this.state;

    this.setState(updateByPropertyName('isLoading', true));

    var createUser = functions.httpsCallable('createUser');
    var email = username + EMAIL_PREFIX;

    createUser({email: email, password:passwordOne})
      .then(authUser => {

        // Create a user in your own accessible Firebase Database too
        db.doCreateUser(authUser.data.uid, username, alias, isModerator, company, telephone )
          .then(() => {
            this.setState(() => ({ ...INITIAL_STATE }));
            toast.success("Vartotojas sukurtas",{
              position: toast.POSITION.BOTTOM_RIGHT
            });
          })
          .catch(error => {
            this.setState(updateByPropertyName('error', error));
            this.setState(updateByPropertyName('isLoading', false));
          });  

      })
      .catch(error => {
        this.setState(updateByPropertyName('error', error));
        this.setState(updateByPropertyName('isLoading', false));
      });

    event.preventDefault();
  }

  render() {
    const {
      username,
      alias,
      passwordOne,
      passwordTwo,
      company,
      telephone,
      isModerator,
      error,
      isLoading
    } = this.state;

    const isInvalid =
      passwordOne !== passwordTwo ||
      passwordOne === '' ||
      username === '' ||
      alias === '';

      if(isLoading){
        return <Spinner></Spinner>
      }
      else{
        return (
          <Form onSubmit={this.onSubmit}>
            <FormGroup>
              <Label>Prisijungimo vardas</Label>
              <Input
                value={username}
                onChange={event => this.setState(updateByPropertyName('username', event.target.value))}
                type="text"
                placeholder="Būtinas laukas"
              />
            </FormGroup>
            <FormGroup>
              <Label>Slaptažodis</Label>
              <Input
                value={passwordOne}
                onChange={event => this.setState(updateByPropertyName('passwordOne', event.target.value))}
                type="password"
                placeholder="Būtinas laukas"
              />
            </FormGroup>
            <FormGroup>  
              <Label>Pakartoti slaptažodį</Label>
                <Input
                value={passwordTwo}
                onChange={event => this.setState(updateByPropertyName('passwordTwo', event.target.value))}
                type="password"
                placeholder="Būtinas laukas"
              />
            </FormGroup>
            <FormGroup>
              <Label>Slapyvardis</Label>
              <Input
                value={alias}
                onChange={event => this.setState(updateByPropertyName('alias', event.target.value))}
                type="text"
                placeholder="Būtinas laukas"
              />
            </FormGroup>

            <FormGroup>
              <Label>Telefonas</Label>
              <Input
                value={telephone}
                onChange={event => this.setState(updateByPropertyName('telephone', event.target.value))}
                type="text"
              />
            </FormGroup>

            <FormGroup>  
              <Label>Įmonė</Label>
                <Input
                value={company}
                onChange={event => this.setState(updateByPropertyName('company', event.target.value))}
                type="select"
              >
    
             {Object.keys(companies).map(key =>{
                    return <option key={key}>{companies[key]}</option>
              })}
    
              </Input>
            </FormGroup>
    
            <FormGroup check>
              <Label check>
                <Input type="checkbox"
                      onChange={event => this.setState(updateByPropertyName('isModerator', event.target.checked))}
                      checked={isModerator}
                />{' '}
                Yra moderatorius
              </Label>
            </FormGroup>  
    
          <div className="create-complain-btn">
            <FormGroup>
            <Button disabled={isInvalid} type="submit">
              Sukurti
            </Button>
            </FormGroup>
          </div>  
            { error && <p>{error.message}</p> }
          </Form>
        );
      }

   
  }
}

const authCondition = (authUser, token) => {
  return !!authUser && token.claims.isAdmin;
  
};

export default compose(withAuthorization(authCondition))(SignUpPage);


// WEBPACK FOOTER //
// ./src/components/SignUp/index.js